<template>
  <div style="display: flex;">
    <div style="width: 100%">
      <v-dialog
          ref="menu"
          :close-on-content-click="false"
          v-model="dialogDate"
          nudge-right="450"
          nudge-bottom="120"
          transition="scale-transition"
          offset-y
          max-width="320"
          v-if="!isDisabled">
        <div class="container-label-selecione">
          <label class="primary--text">Selecione o mês</label>
        </div>
        <div class="container-meses">
          <div :key="mes.id" v-for="mes in mesesAno"
               :class="{ 'mes-item': mesSelecionadoId !== mes.id, 'mes-item mes-item-selecionado': mesSelecionadoId === mes.id }"
               @click="selecionarMes(mes)">
            {{ mes.id }}
          </div>
        </div>
      </v-dialog>
      <v-text-field
          v-model="mesSelecionado"
          :label="label"
          readonly
          :placeholder="placeholder"
          class="az-date-date-input"
          :hide-details="hideDetails"
          :dense="dense"
          @click:append="abrirModalMes">
        <template v-slot:label v-if="this.$slots['label-date']">
          <slot name="label-date"/>
        </template>
        <template v-slot:append>
          <v-btn icon @click="removerMes" v-if="mesSelecionadoId">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn icon @click="abrirModalMes">
            <v-icon>event</v-icon>
          </v-btn>
        </template>
      </v-text-field>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'mes-input',
    props: {
        limparData: {
            type: Boolean,
            default: false
        },
        value: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: 'Selecione o mês'
        },
        isRequired: {
            type: Boolean,
            default: false
        },
        nameDate: {
            type: String,
            default: ''
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        hideDetails: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        autoSelecionar: {
            type: Boolean,
            default: false
        }
    },
    inject: ['$validator'],
    data() {
        return {
            mesesAno: [
                {
                    id: 'JAN.',
                    nome: 'Janeiro',
                    valor: '1',
                },
                {
                    id: 'FEV.',
                    nome: 'Fevereiro',
                    valor: '2',
                },
                {
                    id: 'MAR.',
                    nome: 'Março',
                    valor: '3',
                },
                {
                    id: 'ABR.',
                    nome: 'Abril',
                    valor: '4',
                },
                {
                    id: 'MAI.',
                    nome: 'Maio',
                    valor: '5',
                },
                {
                    id: 'JUN.',
                    nome: 'Junho',
                    valor: '6',
                },
                {
                    id: 'JUL.',
                    nome: 'Julho',
                    valor: '7',
                },
                {
                    id: 'AGO.',
                    nome: 'Agosto',
                    valor: '8',
                },
                {
                    id: 'SET.',
                    nome: 'Setembro',
                    valor: '9',
                },
                {
                    id: 'OUT.',
                    nome: 'Outubro',
                    valor: '10',
                },
                {
                    id: 'NOV.',
                    nome: 'Novembro',
                    valor: '11',
                },
                {
                    id: 'DEZ.',
                    nome: 'Dezembro',
                    valor: '12',
                },
            ],
            dialogDate: false,
            mesSelecionado: null,
            mesSelecionadoId: null,
        }
    },
    mounted() {
        if (this.autoSelecionar) {
            this.selecionarMesAtual()
        }
    },
    methods: {
        selecionarMesAtual() {
            const mesAtual = this.mesesAno.find(mesItem => mesItem.valor === String(moment(new Date()).month() + 1))
            this.selecionarMes(mesAtual)
        },
        selecionarMes(mes) {
            this.mesSelecionado = mes.nome
            this.mesSelecionadoId = mes.id
            this.$emit('input', mes.valor)
            this.dialogDate = false
        },
        abrirModalMes() {
            this.dialogDate = true
        },
        removerMes() {
            this.mesSelecionado = null
            this.mesSelecionadoId = null
            this.$emit('input', null)
        }
    }
}
</script>

<style scoped lang="stylus">

.container-label-selecione
  padding-left 5px
  padding-top 5px
  background-color white
  font-weight bold
  border-bottom 1px solid #ccc
  text-align center

.container-meses
  background-color white
  display grid
  grid-template-columns 100px 100px 100px
  grid-template-rows 50px 50px 50px 50px
  justify-content center
  padding 20px

.mes-item
  display flex
  justify-content center
  align-items center
  font-weight 430

.mes-item:hover
  color black
  background-color #ddd
  cursor pointer

.mes-item-selecionado
  color white
  background-color var(--theme-primary)

</style>